<div class="bl-widget-container" [ngClass]="widgetState.state">
  <div *ngIf="loanManagement && flow">
    <span class="bl-margin-bottom--24"> Default flow is {{ flow?.id }} ({{ flow.config.title }}). </span>
    <div *ngFor="let page of flow.pages" class="bl-margin-bottom--24">
      <a *ngIf="!page.config.type" href="javascript:void()" (click)="gotoPageOfFLow(flow, page)">
        Page: {{ page.id }} - [{{ page.title }}]
      </a>
      <span *ngIf="page.config.type"> Page: {{ page.id }} - [{{ page.title }}] </span>
    </div>
  </div>

  <ng-container *ngIf="!widgetState?.state">
    <router-outlet>
      <div *ngIf="!currentFlow && flow && !loanManagement">
        Default Flow is {{ flow?.id }}.
        <a href="javascript:void()" (click)="gotoFLow()"> Go to first page of flow {{ flow.config.id }} - {{ flow.config.title }} </a>
      </div>
    </router-outlet>
  </ng-container>

  <ng-container *ngIf="widgetState?.state === 'error'">
    <div class="widget-error">
      <p>There was an error on loading workflow</p>
      <p *ngIf="!widgetContext?.config?.isProd">{{ widgetState.message }}</p>
    </div>
  </ng-container>
</div>
